module.exports = __webpack_public_path__ + "static/media/17.04ac6f22.png";